export const MODULE_LABELS = {
  VISA: "Visa",
  INSURANCE: "Insurance",
  RPL_CLIENT: "RPL",
  SKILL_ASSESSMENT: "Skill Assessment",
};

const ENTRY_PATHS = {
  VISA: "/admin/visa/edit",
  INSURANCE: "/admin/insurance/edit",
  RPL_CLIENT: "/admin/rpl-client/edit",
  SKILL_ASSESSMENT: "/admin/skill-assessment/edit",
};

export const moduleLabel = (moduleType) => MODULE_LABELS[moduleType] ?? moduleType;

export const moduleEntryPath = (moduleType, moduleId) =>
  ENTRY_PATHS[moduleType] && moduleId ? `${ENTRY_PATHS[moduleType]}/${moduleId}` : null;

export const isModuleInvoice = (invoice) => Boolean(invoice?.moduleType && invoice?.moduleId);
